import { Injectable } from '@angular/core';
import { GenericActionLinkService, UserAction } from '@mediahaven/shared';
import { ApiFragment } from '@stylehaven/components';
import { MediaHavenActionType } from '../../entities/action-types.entity';

@Injectable({ providedIn: 'root' })
export abstract class ActionLinkService extends GenericActionLinkService<ApiFragment, MediaHavenActionType> {
    // Services

    // Behaviour
    protected readonly ENABLE_BUSY_TOAST: boolean = false;
    protected readonly ENABLE_FINISHED_TOASTS: boolean = false;
    protected readonly REFRESH_ON_ACTION: boolean = false;
    protected readonly DISABLE_ON_EXECUTE: boolean = false;

    /*
    Used internally by getActionItem to build the user action.
    Used externally by the bulk action service to build the user action for each record in the bulk action.
    */
    public abstract userActionBuilder(record: ApiFragment, ...args: any[]): UserAction;

    protected override getDisabledMessage(target: ApiFragment, userAction: UserAction): string {
        return this.tooltipHelper.getActionTooltip(userAction, [target]);
    }
}
